import {queryBuilder} from './common-utils';
import {defaultPartner} from '../config/app-config';
const makeReviewPageUrl = (queryData, partner = defaultPartner) => {
  const queryStringForReviewUrl = queryBuilder(queryData);
  return `/${partner}/hotel-booking/${queryStringForReviewUrl}`;
};

export default makeReviewPageUrl;
